import { IBusTrainRoute } from "../../../../apis/interfaces/IBusTrainRoute";

export function getRouteId(trainRouteObj: IBusTrainRoute) {
    const otpId = trainRouteObj.routeId;
    const idParts = otpId.split(":");
    if (idParts.length === 2) {
        return idParts[1];
    }
    return trainRouteObj.shortName;
}